import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, InstagramIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 md:py-32 bg-cream" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-95">
            <h2 className="font-display text-5xl md:text-6xl text-near-black mb-8" data-id="element-96">
              Find Us
            </h2>
            <p className="text-lg text-near-black/70 font-body mb-10 max-w-md" data-id="element-97">
              We can't wait to welcome you to our salon. Reach out to book your
              appointment or ask any questions.
            </p>

            <div className="space-y-8" data-id="element-98">
              <div className="flex items-start gap-4" data-id="element-99">
                <div className="w-12 h-12 bg-warm-brown rounded-full flex items-center justify-center shrink-0" data-id="element-100">
                  <MapPinIcon className="w-5 h-5 text-brand-gold" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h3 className="font-display text-2xl text-near-black mb-1" data-id="element-103">
                    Location
                  </h3>
                  <p className="font-body text-near-black/70" data-id="element-104">
                    7375 Executive Place
                    <br data-id="element-105" />
                    Suite 214, Lanham MD
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-106">
                <div className="w-12 h-12 bg-warm-brown rounded-full flex items-center justify-center shrink-0" data-id="element-107">
                  <PhoneIcon className="w-5 h-5 text-brand-gold" data-id="element-108" />
                </div>
                <div data-id="element-109">
                  <h3 className="font-display text-2xl text-near-black mb-1" data-id="element-110">
                    Phone
                  </h3>
                  <a href="tel:2409217857" className="font-body text-near-black/70 hover:text-burnt-sienna transition-colors" data-id="element-111">
                    (240) 921-7857
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-112">
                <div className="w-12 h-12 bg-warm-brown rounded-full flex items-center justify-center shrink-0" data-id="element-113">
                  <InstagramIcon className="w-5 h-5 text-brand-gold" data-id="element-114" />
                </div>
                <div data-id="element-115">
                  <h3 className="font-display text-2xl text-near-black mb-1" data-id="element-116">
                    Instagram
                  </h3>
                  <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="font-body text-near-black/70 hover:text-burnt-sienna transition-colors" data-id="element-117">
                    @roziiepse
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-warm-brown p-2 md:p-4 rounded-2xl shadow-2xl relative overflow-hidden h-[400px] md:h-[500px]" data-id="element-118">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3103.743058814561!2d-76.8656126!3d38.9526719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7c0f1b2b3b4b5%3A0x1b2b3b4b5b6b7b8b!2s7375%20Executive%20Pl%20%23214%2C%20Lanham%2C%20MD%2020706!5e0!3m2!1sen!2sus!4v1709999999999!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0,
            borderRadius: '1rem'
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Rozii African Hair Braiding Location" data-id="element-119"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}